import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../app-config';

@Injectable({
  providedIn: 'root'
})
export class TeacherBookingService {
  constructor(
    private httpClient: HttpClient,
    private apiUrl: AppConfig,
  ) { }

  public teachersBookingsAPI = (booking_status: any, page: number): Observable<any> => {
  const params = {
    booking_status: booking_status,
    page: page.toString()
  };

  return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherBookingsAPI, { params });
};

  public bookingAcceptDeclineAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.teacherApiURL.bookingAcceptDeclineAPI, requestData);
  }
  public getTeacherSideComponentAPI = (): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherSideComponentAPI);
  }
} 